import { EventLogger } from '@absmartly/javascript-sdk/types/sdk';
import { v4 as uuid } from 'uuid';
import { PublishAnalyticsEventsDocument } from 'src/generated/graphql';
import { client } from 'src/utils/apollo-client';
import { ExperimentData } from '@absmartly/javascript-sdk/types/context';
import { getVariationName } from './get-variation-key';

type GetEventLoggerProps = {
  deviceId: string;
  experimentMap: Map<string, ExperimentData>;
};
export const getEventLogger =
  ({ deviceId, experimentMap }: GetEventLoggerProps): EventLogger =>
  async (_, eventName, data) => {
    if (eventName === 'publish' && data && 'exposures' in data) {
      if (!data.exposures || data.exposures?.length === 0) return;
      const messages = data.exposures.map((exposure) => {
        const experiment = experimentMap.get(exposure.name);
        const variationKey = getVariationName({
          experiment,
          variantIndex: exposure.variant,
        });
        return {
          exchangeId: 'ANALYTIC_PIPELINE_MOUTH',
          type: 'absmartly_ab_executed',
          id: uuid(),
          payload: {
            frame: {
              deployable_environment: process.env.NEXT_PUBLIC_DEPLOYABLE_ENV,
              deployable_name: 'cardfinder',
              deployable_version: '1.0.0',
              event_occurred_msec_ago: 0,
              event_seqno: 0,
              device_id: deviceId,
            },
            inputs: {
              bucketing_id: deviceId,
              bucketing_id_type: 'device_id',
              experiment_key: exposure.name || '',
              user_attributes: {
                page_url: window.location.href,
              },
              user_attributes_canonical: {},
            },
            model_execution_id: uuid(),
            model_name: 'absmartly',
            model_version: '1.0',
            outputs: {
              enabled: true,
              variation_key: variationKey,
            },
          },
        };
      });
      if (!messages) return;
      return await client.mutate({
        mutation: PublishAnalyticsEventsDocument,
        variables: {
          messages,
        },
      });
    }
  };
